import React from 'react';
import { FormProvider } from 'react-hook-form';

function Form({ onSubmit, methods, children, ...rest }) {
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} {...rest}>
        {children}
      </form>
    </FormProvider>
  );
}

export default Form;
